import React, { useEffect, useState, useRef } from 'react';
import logo from "../../assets/logo.png"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeCartItem, fetchCart, updateCartQuantity, clearCart } from "../../slice/cart/cartSlice";
import profile from "../../websiteAssets/images/profile.jpg"
import { logout } from "../../slice/auth/authSlice";
import Search from "../users/components/search/Search"
const Header = ({ dropdownCategories = [], loading, setShowLoginModal }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { items: cartItems } = useSelector((state) => state.cart);
  const { user, token } = useSelector((state) => state.auth);

  const subtotal = cartItems.reduce(
    (sum, item) => sum + item.totalPrice,
    0
  );

  // Category dropdown state
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const categoryDropdownRef = useRef(null);

  // Profile dropdown state
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileDropdownRef = useRef(null);

  // Alias variables for CUSD dropdown component naming
  const dropdownRef = categoryDropdownRef;
  const isOpen = isCategoryOpen;
  const toggleDropdown = () => setIsCategoryOpen(!isCategoryOpen);

  const handleLogin = () => {
    navigate("/login");
  };

  const handleOrder = () => {
    if (!token) {
      navigate("/login");
      return;
    }
    navigate("/my-orders");
  };



  const handleLogout = () => {
    dispatch(logout());
    dispatch(clearCart());
    setIsProfileOpen(false);
    navigate("/login");
  };
  useEffect(() => {
    if (token) {
      dispatch(fetchCart());
    }
  }, [token, dispatch]);

  const handleRemoveCartItem = (id) => {
    dispatch(removeCartItem(id))
      .unwrap()
      .then(() => {
        dispatch(fetchCart());
      });
  };

  const handleIncreaseQty = (item) => {
    dispatch(
      updateCartQuantity({ id: item._id, quantity: item.quantity + 1 })
    );
  };

  const handleDecreaseQty = (item) => {
    if (item.quantity === 1) {
      dispatch(removeCartItem(item._id))
        .unwrap()
        .then(() => {
          dispatch(fetchCart());
        });
      return;
    }
    dispatch(
      updateCartQuantity({ id: item._id, quantity: item.quantity - 1 })
    );
  };

  const goHome = () => navigate("/");

  const toggleProfileDropdown = () => {
    setIsProfileOpen(!isProfileOpen);
  };

  // Handle click outside for category dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
        setIsCategoryOpen(false);
      }
    };

    if (isCategoryOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isCategoryOpen]);

  // Handle click outside for profile dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    if (isProfileOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProfileOpen]);

  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const Allcategory = () => {
    navigate("/Allcategory");
  };

  return (
    <header className="site-header mo-left header style-2">
      {/* Main Header */}
      <div className="header-info-bar">
        <div className="container clearfix">{/* Website Logo */}</div>
      </div>
      {/* Main Header End */}
      {/* Main Header */}
      <div className="sticky-header main-bar-wraper navbar-expand-lg">
        <div className="main-bar clearfix2">
          <div className="container-fluid clearfix d-lg-flex d-block padding0">
            {/* Website Logo */}
            <div className="logo-header logo-dark">
              <div onClick={goHome}>
                <img src={logo} alt="logo" className='logo' />
              </div>
            </div>
            {/* Nav Toggle Button */}

<div className='flexboX'>
{/*   
                  {token && user ? (
  <div className="nav-item cart-link mobilecart" style={{position:"relative"}}>
    <div
      className="cartdIv"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasRight"
      aria-controls="offcanvasRight"
    >
      <i className="iconly-Broken-Buy" />
      <span className="HeaderCirclered">
        {cartItems.length}
      </span>
    </div>
  </div>
) : (
  <div className="nav-item cart-link mobilecart">
    <div
      className="nav-link cart-btn"
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      title="Please login to view cart"
      style={{ cursor: "pointer" }}
    >
      <i className="iconly-Broken-Buy" />
    </div>
  </div>
)} */}
      <button
              className="navbar-toggler collapsed navicon justify-content-end"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span />
              <span />
              <span />
            </button> 

</div>
            
           
            {/* Main Nav */}
            <div
              className="header-nav w3menu navbar-collapse collapse justify-content-start"
              id="navbarNavDropdown"
            >
              <div onClick={goHome}>
                <img src={logo} alt="logo" className='logo' />
              </div>
              {/* EXTRA NAV */}
              <div className="browse-category-menu">
                <div className="CUSD_dropdown-container" ref={dropdownRef}
                  onMouseEnter={() => setIsCategoryOpen(true)}
                  onMouseLeave={() => setIsCategoryOpen(false)}>
                  <button
                    className={`CUSD_dropdown-button ${isOpen ? 'CUSD_dropdown-button--active' : ''}`}
                    onClick={toggleDropdown}
                  >
                    <span className="CUSD_hamburger-icon">
                      <span className="CUSD_hamburger-line"></span>
                      <span className="CUSD_hamburger-line"></span>
                      <span className="CUSD_hamburger-line"></span>
                    </span>
                    <span className="CUSD_button-text">All CATEGORIES</span>
                    <i className={`icon feather icon-chevron-down ${isOpen ? 'CUSD_chevron-icon--open' : ''}`} />
                  </button>
                  {loading ? (
                    <p className="text-center">Loading...</p>
                  ) : isOpen ? (
                    <div className="CUSD_dropdown-menu">
                      <ul>
                        {dropdownCategories.length > 0 ? (
                          <>
                            {/* Show only first 4 */}
                            {dropdownCategories.slice(0, 4).map((cat) => (
                              <li key={cat._id} className="dropCUS">
                                <a href={`/product/${cat._id}`}>
                                  <i className="icon feather icon-arrow-right" /> &nbsp;
                                  <span>{cat.name}</span>
                                </a>
                              </li>
                            ))}

                            {/* Show View All if more than 4 */}
                            {dropdownCategories.length > 4 && (
                              <li className="dropCUS view-all">
                                <i className="icon feather icon-arrow-right" /> &nbsp;
                                <span className='ALLCAte' onClick={Allcategory}>View All Categories</span>


                              </li>
                            )}
                          </>
                        ) : (
                          <p className="text-center">No categories found</p>
                        )}
                      </ul>
                    </div>
                  ) : null}
                </div>
              </div>


   <ul className="nav navbar-nav desktoponly">
                <li className="has-mega-menu sub-menu-down auto-width menu-left">

                  <a onClick={goHome}>
                    <span>Home</span>
                    <i className="fas fa-chevron-down tabindex" />
                  </a>
                </li>

                <li className="has-mega-menu sub-menu-down auto-width menu-left">
                  <a onClick={handleOrder}>
                    <span>Order Details</span>
                    <i className="fas fa-chevron-down tabindex" />
                  </a>
                </li>
              </ul>

            {/* Mobile-only nav items inside side menu */}
<div className="d-lg-none mobile-sidemenu-extras">
  {token && user ? (
    <>
      <ul className="nav navbar-nav">
        <li className="has-mega-menu sub-menu-down auto-width menu-left">
          <a onClick={() => { navigate("/profile/overview"); }}>
            <i className="fa fa-user-circle me-2"></i>
            <span>Profile Overview</span>
          </a>
        </li>
        <li className="has-mega-menu sub-menu-down auto-width menu-left">
          <a onClick={() => { navigate("/my-orders"); }}>
            <i className="fa-solid fa-box me-2"></i>
            <span>My Orders</span>
          </a>
        </li>
        <li className="has-mega-menu sub-menu-down auto-width menu-left">
          <a onClick={() => { navigate("/favourites"); }}>
            <i className="fa-solid fa-right-from-bracket me-2"></i>
            <span>Wishlist</span>
          </a>
        </li>
      
        <li className="has-mega-menu sub-menu-down auto-width menu-left">
          <a onClick={handleLogout}>
            <i className="fa-solid fa-right-from-bracket me-2"></i>
            <span>Sign Out</span>
          </a>
        </li>
      </ul>
    </>
  ) : (
    <ul className="nav navbar-nav">
      <li className="has-mega-menu sub-menu-down auto-width menu-left">
        <a onClick={handleLogin}>
          <i className="fa fa-sign-in me-2"></i>
          <span>Login / Register</span>
        </a>
      </li>
    </ul>
  )}
</div>
            </div>
            {/* EXTRA NAV */}
            <div className="extra-nav">
              <div className="extra-cell">
                <ul className="header-right">
                  {token && user ? (
                    <li onClick={toggleProfileDropdown} className="nav-item login-link" ref={profileDropdownRef} style={{ position: 'relative' }}>
                      <div className='profileNmae'>
                        <img
                          src={profile}
                          alt="Profile"
                          className="Profile"

                          style={{ cursor: 'pointer' }}
                        />
                        <span className="profile-username">{user?.name}</span>
                      </div>


                      {isProfileOpen && (

                        <div className="profile-dropdown-menu">
                          {/* User Info Header */}




                          {/* Menu Items */}
                          <ul className="profile-menu-list">
                            <li className="profile-menu-item" onClick={() => { navigate("/profile/overview"); setIsProfileOpen(false); }}>
                              <i className="fa fa-user-circle"></i>
                              <span>Profile Overview</span>
                            </li>
                            <li className="profile-menu-item" onClick={() => { navigate("/my-orders"); setIsProfileOpen(false); }}>
                              <i className="fa-solid fa-box"></i>
                              <span>My Orders</span>
                            </li>
                            <li className="profile-menu-item" onClick={() => { navigate("/profile/address"); setIsProfileOpen(false); }}>
                              <i className="fa-solid fa-location-dot"></i>
                              <span>Saved Addresses</span>
                            </li>

                          </ul>

                          <div className="profile-dropdown-divider" />

                          {/* Sign Out */}
                          <ul className="profile-menu-list">
                            <li className="profile-menu-item profile-signout" onClick={handleLogout}>
                              <i className="fa-solid fa-right-from-bracket"></i>
                              <span>Sign out</span>
                            </li>
                          </ul>
                        </div>

                      )}
                    </li>
                  ) : (


                    <ul className="nav navbar-nav">

                      <li className="has-mega-menu sub-menu-down auto-width menu-left">
                        <div onClick={handleLogin}>
                          <span>Login / Register</span>

                        </div>
                      </li>
                    </ul>
                  )}
                  <li className="nav-item search-link">
                    <div
                      className="nav-link"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasTop"
                      aria-controls="offcanvasTop"
                    >
                      <i className="iconly-Light-Search" />
                    </div>
                  </li>
                  <li className="nav-item wishlist-link">
                    <div
                      className="nav-link"
                      onClick={(e) => {
                        e.preventDefault();

                        if (!user || !token) {
                          setShowLoginModal(true);
                          return;
                        }

                        navigate("/favourites");
                      }}
                    >



                      <i className="iconly-Light-Heart2" />
                    </div>
                  </li>

                  {token && user ? (
  <li className="nav-item cart-link">
    <div
      className="nav-link cart-btn"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasRight"
      aria-controls="offcanvasRight"
    >
      <i className="iconly-Broken-Buy" />
      <span className="HeaderCircle">
        {cartItems.length}
      </span>
    </div>
  </li>
) : (
  <li className="nav-item cart-link">
    <div
      className="nav-link cart-btn"
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      title="Please login to view cart"
      style={{ cursor: "pointer" }}
    >
      <i className="iconly-Broken-Buy" />
    </div>
  </li>
)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Header End */}
      {/* SearchBar */}
      <div
        className="dz-search-area dz-offcanvas offcanvas offcanvas-top"
        tabIndex={-1}
        id="offcanvasTop"
      >
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          ×
        </button>
        <div className="container">
          <Search categories={dropdownCategories} />
        </div>
      </div>
      {/* SearchBar */}
      {/* Sidebar cart */}
      <div
        className="offcanvas dz-offcanvas offcanvas offcanvas-end "
        tabIndex={-1}
        id="offcanvasRight"
      >
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          ×
        </button>
        <div className="offcanvas-body">
          <div className="product-description">
            <div className="dz-tabs">
              <ul className="nav nav-tabs center" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="shopping-cart"
                    data-bs-toggle="tab"
                    data-bs-target="#shopping-cart-pane"
                    type="button"
                    role="tab"
                    aria-controls="shopping-cart-pane"
                    aria-selected="true"
                  >
                    Shopping Cart
                    <span className="badge badge-light"> {cartItems.length}</span>
                  </button>
                </li>
              </ul>
              <div className="tab-content pt-4" id="dz-shopcart-sidebar">
                <div
                  className="tab-pane fade show active"
                  id="shopping-cart-pane"
                  role="tabpanel"
                  aria-labelledby="shopping-cart"
                  tabIndex={0}
                >
                  <div className="shop-sidebar-cart">
                    <ul className="sidebar-cart-list">
                      {cartItems.length === 0 ? (
                        <li className="text-center">Cart is empty</li>
                      ) : (
                        cartItems.map((item) => (
                          <li key={item._id}>
                            <div className="cart-widget ADDToMain">
                              <img className='ADDTo'

                                src={`${process.env.REACT_APP_API_URL}/uploads/${item.images[0]}`}
                                alt=""
                              />
                              <div className="cart-content">
                                <h6 className="title">
                                  {item.product?.name}
                                </h6>
                                <div className="d-flex align-items-center">
                                  <div className="btn-quantity light quantity-sm me-3">
                                    <div className="input-group bootstrap-touchspin">
                                      <span
                                        className="input-group-addon bootstrap-touchspin-prefix"
                                        style={{ display: "none" }}
                                      />
                                      <input
                                        type="text"
                                        value={item.quantity}
                                        readOnly
                                        className="form-control"
                                        style={{ display: "block" }}
                                      />
                                      <span
                                        className="input-group-addon bootstrap-touchspin-postfix"
                                        style={{ display: "none" }}
                                      />
                                      <span className="input-group-btn-vertical">
                                        <button
                                          className="btn btn-default bootstrap-touchspin-up"
                                          type="button"
                                          onClick={() => handleIncreaseQty(item)}
                                        >
                                          <i className="fa-solid fa-plus" />
                                        </button>
                                        <button
                                          className="btn btn-default bootstrap-touchspin-down"
                                          type="button"
                                          onClick={() => handleDecreaseQty(item)}
                                        >
                                          <i className="fa-solid fa-minus" />
                                        </button>
                                      </span>
                                    </div>
                                  </div>
                                  <h6 className="dz-price mb-0">{item.price}</h6>
                                </div>
                              </div>
                              <div onClick={() => handleRemoveCartItem(item._id)} className="dz-close">
                                <i className="ti-close" />
                              </div>
                            </div>
                          </li>
                        ))
                      )}
                    </ul>
                    <div className="cart-total">
                      <h5 className="mb-0">Subtotal:</h5>
                      <h5 className="mb-0">₹{subtotal}</h5>
                    </div>
                    <div className="mt-auto">
                      <button
                        className="orangeBtn"
                        onClick={() => navigate("/checkout")}
                      >
                        Checkout
                      </button>

                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="wishlist-pane"
                  role="tabpanel"
                  aria-labelledby="wishlist"
                  tabIndex={0}
                >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Sidebar cart */}
      {/* Sidebar finter */}
      <div
        className="offcanvas dz-offcanvas offcanvas offcanvas-end "
        tabIndex={-1}
        id="offcanvasLeft"
      >
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          ×
        </button>
        <div className="offcanvas-body">
          <div className="product-description">
            <div className="widget widget_search">
              <div className="form-group">
                <div className="input-group">
                  <input
                    name="dzSearch"
                    required="required"
                    type="search"
                    className="form-control"
                    placeholder="Search Product"
                  />
                  <div className="input-group-addon">
                    <button
                      name="submit"
                      value="Submit"
                      type="submit"
                      className="btn"
                    >
                      <i className="icon feather icon-search" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <a
              href="#"
              className="btn btn-sm font-14 btn-secondary btn-sharp"
            >
              RESET
            </a>
          </div>
        </div>
      </div>

      {showScrollTop && (
        <button
          className="scroltop"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <i className="fas fa-arrow-up" />
        </button>
      )}

    </header>
  )
}

export default Header